import { MockComponent } from './mock-component';

export class MeterMock extends MockComponent {
  get canConfig(): boolean | boolean {
    return false;
  }
}
